import { module } from 'stereomodularjs';
import { html } from '../utils/environment';

/*
    USAGE :
    <input type="tel" class="phoneInput" data-module="PhoneFormatter" placeholder="(123) 456-7890">
 */

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            input: 'formatPhoneNumber'
        };
    }

    init() {
        // Format initial value if any
        if (this.el.value) {
            this.el.value = this.format(this.el.value);
        }
    }

    formatPhoneNumber(e) {
        let input = e.target;
        let formatted = this.format(input.value);
        input.value = formatted;
    }

    format(value) {
        // Remove all non-numeric characters
        let numbers = value.replace(/\D/g, '');

        // Format as (123) 456-7890
        if (numbers.length > 10) numbers = numbers.slice(0, 10);

        let formatted = numbers;
        if (numbers.length >= 6) {
            formatted = `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6)}`;
        } else if (numbers.length >= 3) {
            formatted = `(${numbers.slice(0, 3)}) ${numbers.slice(3)}`;
        } else if (numbers.length > 0) {
            formatted = `(${numbers}`;
        }

        return formatted;
    }
}
